import  aesJs  from 'aes-js';
import MD5 from './md5'
export default {
	addressShort(paddress){
		 return paddress.substr(0,7) + '****' + paddress.substr(37,10);  
	},
	guid() {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
	    return v.toString(16);
	  });
	},
	// aesEncryptedEcbHex(plaintext){
	// 	 var preNoice = Date.now();
	// 	 var sufNoice = Date.now() - Math.round(Math.random()*10000); 
	// 	 console.log('aesEncryptedEcbHex()：preNoice=',preNoice);
	// 	console.log('aesEncryptedEcbHex()：sufNoice=',sufNoice );
	// 	// var parms = {'pre':preNoice,'data':plaintext,'suf':sufNoice,}
	// 	 var msgBytes = aesJs.utils.utf8.toBytes(preNoice+','+plaintext+','+sufNoice)
	// 	 //console.log('loadWalletTest()：msgBytes=',msgBytes);
	// 	 var msgBytesPadding = aesJs.padding.pkcs7.pad(msgBytes);
	// 	 //console.log('loadWalletTest()：msgBytesPadding=',msgBytesPadding);  
	// 	 var key = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]; 
	// 	 var aesEcb = new aesJs.ModeOfOperation.ecb(key);
	// 	 var msgEncryptBytes = aesEcb.encrypt(msgBytesPadding);
	// 	 //console.log('loadWalletTest()：msgEncryptBytes=',msgEncryptBytes);
	// 	 var msgEncryptedHex = aesJs.utils.hex.fromBytes(msgEncryptBytes);
	// 	 //console.log('loadWalletTest()：msgEncryptedHex=',msgEncryptedHex);
	// 	 return msgEncryptedHex; 
	// },
	// aesDecryptEcbHex(plaintext){
	// 	 var preNoice = Date.now();
	// 	 var sufNoice = Date.now() - Math.round(Math.random()*10000); 
	// 	 console.log('aesEncryptedEcbHex()：preNoice=',preNoice);
	// 	console.log('aesEncryptedEcbHex()：sufNoice=',sufNoice );
	// 	// var parms = {'pre':preNoice,'data':plaintext,'suf':sufNoice,}
	// 	 var msgBytes = aesJs.utils.utf8.toBytes(preNoice+','+plaintext+','+sufNoice)
	// 	 //console.log('loadWalletTest()：msgBytes=',msgBytes);
	// 	 var msgBytesPadding = aesJs.padding.pkcs7.pad(msgBytes);
	// 	 //console.log('loadWalletTest()：msgBytesPadding=',msgBytesPadding);  
	// 	 var key = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]; 
	// 	 var aesEcb = new aesJs.ModeOfOperation.ecb(key);
	// 	 var msgEncryptBytes = aesEcb.encrypt(msgBytesPadding);
	// 	 //console.log('loadWalletTest()：msgEncryptBytes=',msgEncryptBytes);
	// 	 var msgEncryptedHex = aesJs.utils.hex.fromBytes(msgEncryptBytes);
	// 	 //console.log('loadWalletTest()：msgEncryptedHex=',msgEncryptedHex);
	// 	 return msgEncryptedHex; 
	// },
	aesEncryptedCtrToHex(password,plaintext){
		var preId = this.guid();
		var psalt = this.guid();// Date.now() - Math.round(Math.random()*10000); 
		var pwdMd5 = MD5.md5(password).substr(0, 16);
		//console.log('aesEncryptedCtrHex()：pwdMd5=',pwdMd5);
		var pwdMD5Bytes = aesJs.utils.utf8.toBytes(pwdMd5);
		//console.log('aesEncryptedCtrHex()：pwdMD5Bytes=',pwdMD5Bytes);
		var aesCtr = new aesJs.ModeOfOperation.ctr(pwdMD5Bytes, new aesJs.Counter(5));
		var dataBytes = aesJs.utils.utf8.toBytes('{"id":"'+preId+'","key":"' + plaintext + '","salt":"'+psalt+'"}');
		var dataEncryptBytes = aesCtr.encrypt(dataBytes);
		//console.log('loadWalletTest()：dataEncryptBytes=',dataEncryptBytes); 
		var dataHex = aesJs.utils.hex.fromBytes(dataEncryptBytes);
		//console.log('loadWalletTest()：msgEncryptedHex=',dataHex);
		return dataHex;
	},
	aesDecryptCtrFromHex(password,encrypttext){
		
		var dataEncryptBytes = aesJs.utils.hex.toBytes(encrypttext);
		var pwdMd5 = MD5.md5(password).substr(0, 16);
		//console.log('aesDecryptCtrFromHex()：pwdMd5=',pwdMd5);
		var pwdMD5Bytes = aesJs.utils.utf8.toBytes(pwdMd5);
		//console.log('aesDecryptCtrFromHex()：pwdMD5Bytes=',pwdMD5Bytes);
		var aesCtr = new aesJs.ModeOfOperation.ctr(pwdMD5Bytes, new aesJs.Counter(5));		
		//  console.log('aesDecryptCtrFromHex()：dataEncryptBytes=',dataEncryptBytes);
		var dataBytes = aesCtr.decrypt(dataEncryptBytes);
		console.log('aesDecryptCtrFromHex()：dataBytes=',dataBytes);
		var plaintext = aesJs.utils.utf8.fromBytes(dataBytes);
		console.log('aesDecryptCtrFromHex()：plaintext=',plaintext); 
		return plaintext;
	}	
}

export function aesEncryptedHex(plaintext){ 
 	
}
	
// export function in_array(search,array){
// 	let flag = false;
// 	for(let i in array){
// 		if(array[i]==search){
// 			flag = true;
// 			break;
// 		}
// 	}

// 	return flag;
// }

// export function isDataType(data,type){
// 	return Object.prototype.toString.call(data) === '[object '+type+']';
// }

// export function ltrim(str,char){
// 	let pos = str.indexOf(char);
// 	let sonstr = str.substr(pos+1);
// 	return sonstr;
// }

// export function rtrim(str,char){
// 	let pos = str.lastIndexOf(char);
// 	let sonstr = str.substr(0,pos);
// 	return sonstr;
// }

 

// export function prePage(){
// 	let pages = getCurrentPages();
// 	let prePage = pages[pages.length - 2];
// 	// #ifdef H5
// 	return prePage;
// 	// #endif
// 	return prePage.$vm;
// }

 